import { db, getDoc, doc, updateDoc, getDocs, collection, where, query } from "../firebaseConfig";
const { DateTime } = require("luxon");

export const checkInvoiceStatus = async (jobID, jobData, lists, moveCards = false) => {
  if (jobID) {
    const docSnap = await getDoc(doc(db, "JobData", jobID));
    if (docSnap.exists()) {
      jobData = docSnap.data();
      jobData.id = jobID;
    }
  }
  const invoicedLabelID = "5e6881d6af988c41f2bf6e13";
  const suppliedLabelID = "5e6881d6af988c41f2bf6e12";
  const paidLabelID = "5e6881d6af988c41f2bf6e11";
  const voidedLabelID = "9fe322b0-e087-44ba-888a-72b46847f5b7";
  const noChargeID = "6188524beae9be159b674168";

  const completeListID = "53403bfe-b716-4791-9d23-d3678950e2e0";

  if (!jobData.jobNumber) {
    console.log("No job number available to check invoices");
    return;
  }

  if (
    jobData?.idLabels.includes(noChargeID) ||
    jobData?.idLabelsPermanent.includes(noChargeID)
  ) {
    updateDoc(doc(db, "JobData", jobData.id),{ complete: true });
    if (moveCards) {
      moveList(
        {
          target: { value: completeListID },
        },
        jobData,
        lists
      );
    }
    return;
  }

  getDocs(
    query(
      collection(db, "xero-invoices"),
      where("containsJobNumbers", "array-contains", jobData.jobNumber.toString())
    )
  )
    .then(async (querySnapshot) => {
      if (querySnapshot.empty) {
        console.log("No invoices found for this job");
        return;
      }

      console.log("invoiced");
      
      const invoices = querySnapshot.docs.map((doc) => doc.data());
      
      const getPaymentStatus = (invoice) => {
        if (invoice.Status === "VOIDED") {
          return "Voided";
        } else if (invoice.AmountDue <= 0 && invoice.Total > 0) {
          return "Paid";
        } else if (invoice.AmountPaid > 0 && invoice.AmountDue > 0) {
          return "Partially Paid";
        } else {
          return "Unpaid";
        }
      };

      const hasSentToContact = invoices.some(invoice => invoice.SentToContact === true);
      
      const hasVoidedInvoice = invoices.some(
        (invoice) => getPaymentStatus(invoice) === "Voided"
      );
      
      const allPaid = invoices.every(
        (invoice) => getPaymentStatus(invoice) === "Paid"
      );

      if (hasSentToContact && !jobData?.idLabels.includes(invoicedLabelID)) {
        // Add the label if any invoice has been sent to contact
        jobData?.idLabels.push(invoicedLabelID);
        console.log("Adding invoiced label - SentToContact is true");
      } else if (!hasSentToContact && jobData?.idLabels.includes(invoicedLabelID)) {
        // Remove the label if no invoices have been sent to contact
        console.log("Removing invoiced label - SentToContact is false");
        const labelIndex = jobData.idLabels.indexOf(invoicedLabelID);
        if (labelIndex !== -1) {
          jobData.idLabels.splice(labelIndex, 1);
        }
      }
      
      // Add voided label if any invoice is voided
      if (hasVoidedInvoice) {
        if (!jobData?.idLabels.includes(voidedLabelID)) {
          jobData?.idLabels.push(voidedLabelID);
        }
      }

      if (allPaid) {
        if (!jobData?.idLabels.includes(paidLabelID)) {
          jobData?.idLabels.push(paidLabelID);
        }

        const jobYear = parseInt(jobData.jobNumber.toString().substring(0, 2));

        if (jobYear <= 23) {
          if (!jobData?.idLabels.includes(suppliedLabelID)) {
            jobData?.idLabels.push(suppliedLabelID);
          }
          updateDoc(doc(db, "JobData", jobData.id), { complete: true, expressComplete: true });
          if (moveCards) {
            moveList(
              {
                target: { value: completeListID },
              },
              jobData,
              lists
            );
          }
        } else {
          if (
            jobData?.idLabels.includes(suppliedLabelID) ||
            jobData?.idLabelsPermanent.includes(suppliedLabelID)
          ) {
            updateDoc(doc(db, "JobData", jobData.id), { complete: true, expressComplete: true });
            if (moveCards) {
              moveList(
                {
                  target: { value: completeListID },
                },
                jobData,
                lists
              );
            }
          }
        }
      }

      await updateDoc(doc(db, "JobData", jobData.id),{ idLabels: jobData.idLabels });
    })
    .catch((error) => {
      console.error("Error checking invoice status:", error);
    });
};

const moveList = async (e, jobData, lists) => {
  const targetList = lists.find((list) => list.id === e.target.value);
  if (targetList && targetList.items.includes(jobData.id)) {
    return;
  }

  if (e.target.value === "0367cb77-644f-4d57-b4e8-4286148218d7") {
    if (jobData.idLabels.indexOf("6285ea079131e28982c19d39") === -1) {
      jobData.idLabels.push("6285ea079131e28982c19d39");
    }
    updateDoc(doc(db, "JobData", jobData.id),{ idLabels: jobData.idLabels });
  }

  if (e.target.value === "bbb73c17-6690-4d43-8569-be12b0d5ee27") {
    if (jobData.idLabels.indexOf("5e6881d6af988c41f2bf6e14") === -1) {
      jobData.idLabels.push("5e6881d6af988c41f2bf6e14");
    }
    updateDoc(doc(db, "JobData", jobData.id),{ idLabels: jobData.idLabels });
  }

  lists.forEach((list) => {
    if (list.items.indexOf(jobData.id) !== -1) {
      list.items.splice(list.items.indexOf(jobData.id), 1);
    }
    if (list.id === e.target.value) {
      if (!list.items.includes(jobData.id)) {
        list.items.push(jobData.id);
      }
    }
  });

  lists.forEach((list) => {
    const noDupes = [...new Set(list.items)];
    list.items = noDupes;
  });

  await updateDoc(doc(db, "AdminCollection", "lists"), { lists: lists });

  if (e.target.value === "5f081763cd97556d03075c86") {
    updateDoc(doc(db, "JobData", jobData.id),{
        isInShooting: true,
        isInShootingTime: DateTime.now()
          .setZone("Australia/Sydney")
          .startOf("day")
          .toUTC()
          .toISO(),
      });
  } else {
    updateDoc(doc(db, "JobData", jobData.id), {
      isInShooting: false,
      isInShootingTime: null,
    });
  }
};
